export default __webpack_public_path__ + "assets/webgl/picking-23.928c2bbc.glb";